import { EnumBase } from 'hay-core-react';
class ConfiguracaoTamanhoFonteCaptiveEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.configuracao.tamanhofontecaptive.pequeno',
                'main.configuracao.tamanhofontecaptive.menor',
                'main.configuracao.tamanhofontecaptive.normal',
                'main.configuracao.tamanhofontecaptive.maior',
                'main.configuracao.tamanhofontecaptive.grande',
            ],
            'main.configuracao.tamanhofontecaptive.normal'
        );
    }
}

const instance = new ConfiguracaoTamanhoFonteCaptiveEnum();
export default instance;
